// extracted by mini-css-extract-plugin
export var measureBox = "_63-0";